import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXGridModule } from '../grid/grid.module';
import { UBXIconModule } from '../icon/icon.module';
import { UBXButtonModule } from '../button/button.module';
import { UBXDatepickerModule } from '../datepicker/datepicker.module';

import { UBXFormComponent } from './form.component';
import { UBXFieldBlockComponent } from './block/field-block.component';
import { UBXFieldLabelComponent } from './label/field-label.component';
import { UBXFieldBoxDirective } from './box/field-box.directive';
import { UBXFieldMessageComponent } from './message/field-message.component';
import { UBXInputComponent, UBXOptionComponent, UBXSelectComponent } from './fields';

export { UBXFormComponent } from './form.component';

const Imports = [
    UBXGridModule,
    UBXIconModule,
    UBXButtonModule,
    UBXDatepickerModule,
];
const Module = [
    UBXFormComponent,
    UBXFieldBlockComponent,
    UBXFieldLabelComponent,
    UBXFieldBoxDirective,
    UBXFieldMessageComponent,

    UBXInputComponent,
    UBXOptionComponent,
    UBXSelectComponent,
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXFormModule {}
